import React from 'react';
import { Link } from 'react-router-dom';
import Lockup from './ui/Lockup';

const Footer = () => (
  <footer className="bg-canvas border-t border-line mt-20">
    <div className="max-w-screen-2xl mx-auto px-8 py-10 grid gap-8 sm:grid-cols-3">
      <div>
        <Lockup className="h-6 w-auto text-ink" />
        <p className="text-slate text-xs mt-3 max-w-xs leading-relaxed">
          Amsterdam technology company specialised in FinTech.
        </p>
      </div>

      <div className="text-xs text-slate space-y-1">
        <p className="text-navy text-sm font-medium mb-2">Contact</p>
        <p>
          <a href="mailto:nigel@arqnxs.com" className="hover:text-navy">
            nigel@arqnxs.com
          </a>
        </p>
        <p>
          <a href="tel:+34610795008" className="hover:text-navy">
            +34 610 795 008
          </a>
        </p>
        <p>NCAGE H2R48 · DUNS 492291297</p>
      </div>

      <div className="text-xs text-slate space-y-1">
        <p className="text-navy text-sm font-medium mb-2">Elsewhere</p>
        <p>
          <a
            href="https://www.linkedin.com/company/arqnxs/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-navy"
          >
            LinkedIn
          </a>
        </p>
        <p>
          <a
            href="https://github.com/ARQNXS/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-navy"
          >
            GitHub
          </a>
        </p>
        <p>
          <a
            href="https://x.com/arqnxs"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-navy"
          >
            X
          </a>
        </p>
        <p className="pt-2">
          <Link to="/about" className="hover:text-navy">
            About
          </Link>
        </p>
      </div>
    </div>

    <div className="border-t border-line py-4 px-8 text-[10px] text-slate">
      <p className="max-w-3xl mx-auto text-center leading-relaxed">
        ARQNXS is a technology company. It is not an authorised investment
        firm and does not provide investment services, portfolio management,
        or investment advice. Nothing on this website constitutes investment
        advice, a recommendation, or an offer or solicitation to buy or sell
        any financial instrument or digital asset. Digital assets and
        derivatives carry significant risk, including the loss of all capital.
        Figures cited describe technology usage, not investment performance;
        past results are no indication of future outcomes.
      </p>
      <p className="text-center mt-3">
        © {new Date().getFullYear()} ARQNXS. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
